import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import './BraspressInfrastructure.css'
import Divider from '../../components/Divider/Divider';
import PageTitle from '../../components/PageTitle/PageTitle';
import CardVision from '../../components/CardVision/CardVision';
import { primary } from '../../theme/colors';
import CardImgDistribution from '../../components/CardImgDistribution/CardImgDistribution';
import CardInfoIcon from '../../components/CardInfoIcon/CardInfoIcon';
import Slide from '../../components/Slide/Slide';


const BraspressInfrastructure = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/about.json`);
    const {
        intro,
        // breadcrumb,
        // selectedPage,
        // breadCrumbImage,
        // vision,
        visionCards,
        competitiveAdvTitle,
        competitiveAdvContent,
        competitiveAdvContentList1,
        competitiveAdvContentList2,
        structureBtu,
        structureBtuList,
        distributionTitle,
        distributionContent,
        distributionIntro,
        distributionCards,
        transportWhitBacIntro,
        transportWhitBacLink
    } = data
    const dataHome = require(`../../assets/languages/${language}/home.json`);
    const {
        operationBase,
        structureOperationBase,
        operationBaseItens,
    } = dataHome

    const TransportWhitBac = () => {
        return (
            <div className='about-transport-whit-bac-container mg-bot-100'>
                <div>
                    <span className='text-title-secondary'>{transportWhitBacIntro}</span>
                    <span dangerouslySetInnerHTML={{ __html: transportWhitBacLink }}></span>
                </div>
            </div>
        )
    }

    return (
        <>
            <Breadcrumb
                beforeRoutes={[
                    {
                        "label": "Home",
                        "value": "/"
                    },
                    {
                        "label": "Diferenciais",
                        "value": null,
                        "disabled": true
                    }
                ]}
                selectedPage={'Infra-estrutura Braspress'}
                ignoreMgBot={true}
            />
            <div className='main-container mg-top-100 mg-bot-100'>
                <section className="section-container">
                    <div className='container-about-intro'>
                        <div className='about-intro'>
                            <span dangerouslySetInnerHTML={{ __html: intro }} className='text-primary text-intro'></span>
                            <Divider width='60%' margin='30px 0' />
                        </div>
                    </div>

                    <div className='about-vision' id='about-vision'>
                        <PageTitle title={'Infra-estrutura Braspress'} />
                        <div className='container-card-vision d-none'>
                            {visionCards.map((d, i) => {
                                return (
                                    <CardVision key={i} title={d.title} iconName={d.iconName} classColor={d.classColor} content={d.content} _className={d.className} />
                                )
                            })}
                        </div>
                    </div>

                    <div className='competitive-advantages d-none' id='competitive-advantages'>
                        <PageTitle title={competitiveAdvTitle} />
                        <span dangerouslySetInnerHTML={{ __html: competitiveAdvContent }}></span>
                        <div className='container-competitive-advantages-list'>
                            <div className='container-competitive-advantages-list-item'>
                                {competitiveAdvContentList1.map((d, i) =>  <li key={i}>{d}</li> )}
                            </div>
                            <div className='container-competitive-advantages-list-item'>
                                {competitiveAdvContentList2.map((d, i) =>  <li key={i}>{d}</li> )}
                            </div>
                        </div>
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: structureBtu }} className='text-primary text-intro mg-bot-20'></span>

                    <div className='container-card-info'>
                        {structureBtuList.map((d, i) => <CardInfoIcon key={i} iconName={d.iconName} title={d.title} content={d.content} />)}
                    </div>

                </section>
            </div>

            <div className='main-container about-main-distribution mg-bot-100 d-none'>
                <section className="section-container">
                    <PageTitle title={distributionTitle} primaryColor={primary.primary300} />
                    <div className='mg-bot-50'>
                        <span dangerouslySetInnerHTML={{ __html: distributionContent }} className='white100'></span>
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: distributionIntro }} className='text-primary text-intro white100'></span>
                    {distributionCards.map((d, i) => {
                        return <CardImgDistribution key={i} image={d.image} title={d.title} textClassName={d.textClassName} />
                    })}
                </section>
            </div>

            <div className='main-container bg-primary100'>
                    <div className='section-container'>
                        <PageTitle title={operationBase} subtitle={structureOperationBase} secondaryColor={'var(--white100)'} />
                    </div>
                </div>
                <div className='main-container bg-primary100'>
                    <Slide
                        // autoPlay={true}
                        // autoPlayDuration={1000}
                        // isFade={true}
                        // isCircle={true}
                        data={operationBaseItens}
                    />
                </div>

            <div className='main-container d-none'>
                <div className="section-container">
                    {TransportWhitBac()}
                </div>
            </div>


        </>

    );
};

export default BraspressInfrastructure;